// Collapse all buttons in recharge bundles widget:
document.addEventListener('DOMContentLoaded', function() {
    let lastButtonCount = 8;
    function clickCollapsibleButtons() {
        const buttons = document.querySelectorAll('button[id^="collapsible-header"]');
        if (buttons.length > lastButtonCount) {
            // Wait 1s before clicking to ensure all are loaded
            setTimeout(() => {
                for (let i = 1; i < buttons.length; i++) {
                    if (!buttons[i].dataset.clicked && buttons[i].getAttribute("aria-expanded") !== "false") {
                        buttons[i].click();
                        buttons[i].dataset.clicked = 'true';
                        // console.log("click")
                    }
                }
                lastButtonCount = buttons.length;
            }, 200);
        }
    }

    clickCollapsibleButtons();

    const observer = new MutationObserver(() => {
        clickCollapsibleButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
});